import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@utils/directives.js";
import Tooltip from "./utils/TooltipDirective";
import dateClass from "./helpers/date";
Vue.use(Tooltip);
// dil seçenekleri.
import i18n from "@/helpers/i18n.js";

const date = new dateClass(i18n.locale);

Vue.prototype.$date = date;

import * as VueGoogleMaps from "vue2-google-maps";
import mapkey from "./constants/map.key.json";
Vue.use(VueGoogleMaps, {
  load: {
    key: mapkey.GOOGLE_MAP_KEY,
    libraries: "places,visualization", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

//select box
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

// Use v-calendar & v-date-picker components
import VCalendar from "v-calendar";
Vue.use(VCalendar);

// EXCELL
import excel from "vue-excel-export";
Vue.use(excel);

//loadings
import Loading from "@/components/Base/Loading/Loading.vue";
import PageLoading from "@/components/Base/Loading/PageLoading.vue";

import SetWorkedDayForTarget from "@/components/SaleTarget/SetWorkedDayForTarget.vue";

Vue.component("SetWorkedDayForTarget", SetWorkedDayForTarget);

Vue.component("Loading", Loading);
Vue.component("PageLoading", PageLoading);

import "@/assets/scss/main.scss";

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
